// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".9b336387cad1488a5585bfa6a0ade54f894f8908.chunk.js";
};